import { useQuery } from '@tanstack/react-query';
import { getMonthlyBillsStats } from '@/apis/admin';
import { QUERY_KEY } from '@/constants/queryKey';
import Text from '@/components/common/Text';
import * as S from './style';

const MonthlyBillStats = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QUERY_KEY.ADMIN.MONTHLY_BILLS_STATS],
    queryFn: () => getMonthlyBillsStats(),
  });

  if (isLoading) {
    return <Text>로딩 중...</Text>;
  }

  if (isError) {
    return (
      <Text color="red">
        통계 조회 실패: {error instanceof Error ? error.message : '알 수 없는 오류'}
      </Text>
    );
  }

  const stats = data?.data;

  if (!stats) {
    return null;
  }

  return (
    <S.StatsContainer>
      <S.StatItem>
        <Text fontWeight={600}>전체:</Text>
        <Text fontWeight={700}>{stats.total}</Text>
      </S.StatItem>
      <S.StatItem urgent={stats.pending_confirmation > 0}>
        <Text fontWeight={600}>확인 대기:</Text>
        <Text fontWeight={700}>{stats.pending_confirmation}</Text>
      </S.StatItem>
      <S.StatItem urgent={stats.overdue > 0}>
        <Text fontWeight={600}>연체:</Text>
        <Text fontWeight={700}>{stats.overdue}</Text>
      </S.StatItem>
      <S.StatItem>
        <Text fontWeight={600}>결제 완료:</Text>
        <Text fontWeight={700}>{stats.paid}</Text>
      </S.StatItem>
      <S.StatItem>
        <Text fontWeight={600}>총 금액:</Text>
        <Text fontWeight={700}>{stats.total_amount.toLocaleString()}원</Text>
      </S.StatItem>
    </S.StatsContainer>
  );
};

export default MonthlyBillStats;

